import * as React from 'react';
import * as AvatarPrimitive from '@radix-ui/react-avatar';

import { cn } from '../../lib/utils';

function Avatar({ className, ...props }) {
    return (
        <AvatarPrimitive.Root
            data-slot="avatar"
            className={cn(
                'tw-relative tw-flex tw-size-8 tw-shrink-0 tw-overflow-hidden tw-rounded-full',
                className
            )}
            {...props}
        />
    );
}

function AvatarImage({ className, ...props }) {
    return (
        <AvatarPrimitive.Image
            data-slot="avatar-image"
            className={cn('tw-aspect-square tw-size-full', className)}
            {...props}
        />
    );
}

function AvatarFallback({ className, ...props }) {
    return (
        <AvatarPrimitive.Fallback
            data-slot="avatar-fallback"
            className={cn(
                'tw-flex tw-size-full tw-items-center tw-justify-center tw-rounded-full tw-bg-muted',
                className
            )}
            {...props}
        />
    );
}

export { Avatar, AvatarImage, AvatarFallback };
